export const languages = [
  {
    code: 'en',
    name: 'English',
    country_code: 'gb',
    image: 'English-icon.svg',
    image2: 'English-icon-eu.png',
  },
  {
    code: 'fr',
    name: 'Français',
    country_code: 'fr',
    image: 'french-icon.svg',
    image2: 'french-icon.svg',
  },
  {
    code: 'es',
    name: 'Español',
    country_code: 'es',
    image: 'spanish-icon.svg',
    image2: 'spanish-icon-eu.png',
  },
];

export const noEnlanguages = [
  {
    code: 'fr',
    name: 'Français',
    country_code: 'fr',
    image: 'french-icon.svg',
    image2: 'french-icon.png',
  },
  {
    code: 'es',
    name: 'Español',
    country_code: 'es',
    image: 'spanish-icon.svg',
    image2: 'spanish-icon-eu.png',
  },
];
